import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';

import LegendCell from './LegendCell';
import LegendDescription from './LegendDescription';
import Modal from './Modal';

class LayerLegendCell extends Component {

  state = {
    isDescriptionOpen: false,
  }

  showDescription(show) {
    this.setState({isDescriptionOpen: show});
  }

  // Wrap LegendCell and LegendDescription in a smart component parent.
  // By forcing these components to be siblings instead of parent-child,
  // we prevent onClick events from making their way from the Modal back to the
  // LegendCell.
  render() {
    return (
      <div ref="target" className="LayerLegendCell">
        <LegendCell
          title={this.props.title}
          styleName={this.props.styleName}
          onClick={() => this.showDescription(true)}
        />
        <Modal
          target={ props => findDOMNode(this.refs.target)}
          placement="right"
          show={this.state.isDescriptionOpen}
          onHide={() => this.showDescription(false)}
        >
          <LegendDescription
            className="LegendDescription"
            description={this.props.description}
          />
        </Modal>
      </div>
    );
  }
}

LayerLegendCell.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  styleName: PropTypes.string.isRequired,
};

export default LayerLegendCell;



// WEBPACK FOOTER //
// ./src/components/LayerLegendCell.js